import { FC } from "react";

import { FontSizes, Text } from "@bps/fluent-ui";
import { Contact } from "@stores/practice/models/Contact.ts";

interface ContactsWithDuplicatedMobileProps {
  title: string;
  contacts: Contact[];
}

export const ContactsWithDuplicatedMobile: FC<
  ContactsWithDuplicatedMobileProps
> = ({ title, contacts }) => {
  const fontStyles = {
    root: { fontSize: FontSizes.small, color: "inherit" }
  };

  if (contacts.length === 0) return null;

  return (
    <Text styles={fontStyles}>
      <Text styles={fontStyles} bold>
        {title}:&nbsp;
      </Text>
      <Text styles={{ root: { fontSize: FontSizes.small } }}>
        {contacts.map((contact: Contact) => contact.name).join(", ")}
      </Text>
    </Text>
  );
};
